import { ArticleViewProps } from '@roc-digital/ui-lib';
import { ActionBar } from './ActionBar';
import { MetaBar } from './MetaBar';
import { Card } from './Card';
import { ArticleHeadline } from './ArticleHeadline';
import { ArticleImage } from './ArticleImage';

/**
 * Alignment Rules:
 *  - Flex Grow: Should grow equally with other siblings
 *  - Minimum Width: 340px;
 *  - Heights
 *    - Large: 400
 *    - Med: 400
 *    - Small: 231
 */
export function Landscape(props: ArticleViewProps) {

  const showActions = props.actions !== false;

  const header = <ArticleImage
    className={`bg-gray-200 h-[237px]`}
    height={237}
    src={props.article.image}
    blurhash={props.article?.blurhash}
    style={{ objectFit: 'cover' }}
    onClick={() => props.onAction && props.onAction({action: 'open', articleId: props.article.id})}
    mini={false}
    href={props.article.href}
  />;

  return <Card
    noFrame={props.noFrame}
    className={`landscape-article ${props.className}`}
    orientation={'landscape'}
    header={header}
  >
    {props.hideMeta !== true ? <>
      <MetaBar
        logo={props.article.logo}
        timeLapse={props.article.timeLapse}
        tag={props.hideTag !== true ? props.article.tag : undefined}
      />
    </> : <></>}
    <ArticleHeadline
      size={props.size}
      headline={props.article.headline}
      blurhash={props.article?.blurhash}
      onClick={() => props.onAction && props.onAction({action: 'open', articleId: props.article.id})}
      children={props.children}
      href={props.article.href}
    />
    {showActions ?
      <ActionBar
        bookmarked={props.article.bookmarked}
        voted={props.article.voted}
        upvotes={props.article.upvotes || 0}
        downvotes={props.article.downvotes || 0}
        articleId={props.article.id || ''}
        comments={props.article.comments}
        onAction={props.onAction || (() => {})}/>
    : null}
  </Card>;
}
